import { useAppBarVisibility } from '../../hooks/useAppBarVisibility';
import { Header } from './Header';
import { Footer } from './Footer';

interface LayoutProps {
    children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
    const showAppBar = useAppBarVisibility();

    return (
        <div className={`min-h-screen flex flex-col ${!showAppBar ? 'h-screen overflow-auto' : ''}`}>
            {showAppBar && <Header />}
            <main className={`flex-1 ${showAppBar ? 'pt-16' : 'pt-0'} ${!showAppBar ? 'h-full' : ''}`}>
                {children}
            </main>
            {showAppBar && <Footer />}
        </div>
    );
};